import { render, staticRenderFns } from "./GridTableComponent.vue?vue&type=template&id=32e1b32e&scoped=true&lang=pug"
import script from "./GridTableComponent.vue?vue&type=script&lang=ts"
export * from "./GridTableComponent.vue?vue&type=script&lang=ts"
import style0 from "./GridTableComponent.vue?vue&type=style&index=0&id=32e1b32e&scoped=true&lang=css"
import style1 from "./GridTableComponent.vue?vue&type=style&index=1&id=32e1b32e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e1b32e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e1b32e')) {
      api.createRecord('32e1b32e', component.options)
    } else {
      api.reload('32e1b32e', component.options)
    }
    module.hot.accept("./GridTableComponent.vue?vue&type=template&id=32e1b32e&scoped=true&lang=pug", function () {
      api.rerender('32e1b32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/GridTable/GridTableComponent.vue"
export default component.exports